/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'ga',
  Pagination: {
    items_per_page: '/ leathanach',
    jump_to: 'Téigh',
    jump_to_confirm: 'dheimhnigh',
    page: '',
    prev_page: 'Leathanach Roimhe Seo',
    next_page: 'An chéad leathanach eile',
    prev_5: '5 leathanach roimhe seo',
    next_5: 'Ar Aghaidh 5 Leathanaigh',
    prev_3: '3 leathanach roimhe seo',
    next_3: 'Ar Aghaidh 3 Leathanaigh'
  },
  DatePicker: {
    lang: {
      placeholder: 'Roghnaigh dáta',
      yearPlaceholder: 'Roghnaigh bliain',
      quarterPlaceholder: 'Roghnaigh ráithe',
      monthPlaceholder: 'Roghnaigh mí',
      weekPlaceholder: 'Roghnaigh seachtain',
      rangePlaceholder: ['Dáta tosaigh', 'Dáta deiridh'],
      rangeYearPlaceholder: ['Tús na bliana', 'Deireadh na bliana'],
      rangeMonthPlaceholder: ['Tosaigh mhí', 'Deireadh mhí'],
      rangeWeekPlaceholder: ['Tosaigh an tseachtain', 'Deireadh na seachtaine'],
      locale: 'ga_IE',
      today: 'inniu',
      now: 'anois',
      backToToday: 'Ar ais inniu',
      ok: 'ceart go leor',
      clear: 'soiléir',
      month: 'mhí',
      year: 'bhliain',
      timeSelect: 'roghnaigh am',
      dateSelect: 'roghnaigh dáta',
      weekSelect: 'Roghnaigh seachtain',
      monthSelect: 'Roghnaigh mí',
      yearSelect: 'Roghnaigh bliain',
      decadeSelect: 'Roghnaigh deich mbliana',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'An mhí roimhe seo (PageUp)',
      nextMonth: 'An mhí seo chugainn (PageDown)',
      previousYear: 'Anuraidh (Control + left)',
      nextYear: 'An bhliain seo chugainn (Control + right)',
      previousDecade: 'Le deich mbliana anuas',
      nextDecade: 'Deich mbliana amach romhainn',
      previousCentury: 'An chéid seo caite',
      nextCentury: 'An chéad aois eile'
    },
    timePickerLocale: {
      placeholder: 'Roghnaigh am',
      rangePlaceholder: ['Am tosaigh', 'Am deiridh']
    }
  },
  TimePicker: {
    placeholder: 'Roghnaigh am',
    rangePlaceholder: ['Am tosaigh', 'Am deiridh']
  },
  Calendar: {
    lang: {
      placeholder: 'Roghnaigh dáta',
      yearPlaceholder: 'Roghnaigh bliain',
      quarterPlaceholder: 'Roghnaigh ráithe',
      monthPlaceholder: 'Roghnaigh mí',
      weekPlaceholder: 'Roghnaigh seachtain',
      rangePlaceholder: ['Dáta tosaigh', 'Dáta deiridh'],
      rangeYearPlaceholder: ['Tús na bliana', 'Deireadh na bliana'],
      rangeMonthPlaceholder: ['Tosaigh mhí', 'Deireadh mhí'],
      rangeWeekPlaceholder: ['Tosaigh an tseachtain', 'Deireadh na seachtaine'],
      locale: 'ga_IE',
      today: 'inniu',
      now: 'anois',
      backToToday: 'Ar ais inniu',
      ok: 'ceart go leor',
      clear: 'soiléir',
      month: 'mhí',
      year: 'bhliain',
      timeSelect: 'roghnaigh am',
      dateSelect: 'roghnaigh dáta',
      weekSelect: 'Roghnaigh seachtain',
      monthSelect: 'Roghnaigh mí',
      yearSelect: 'Roghnaigh bliain',
      decadeSelect: 'Roghnaigh deich mbliana',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'An mhí roimhe seo (PageUp)',
      nextMonth: 'An mhí seo chugainn (PageDown)',
      previousYear: 'Anuraidh (Control + left)',
      nextYear: 'An bhliain seo chugainn (Control + right)',
      previousDecade: 'Le deich mbliana anuas',
      nextDecade: 'Deich mbliana amach romhainn',
      previousCentury: 'An chéid seo caite',
      nextCentury: 'An chéad aois eile'
    },
    timePickerLocale: {
      placeholder: 'Roghnaigh am',
      rangePlaceholder: ['Am tosaigh', 'Am deiridh']
    }
  },
  global: {
    placeholder: 'Please select'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    selectionAll: 'Select all data',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row',
    triggerDesc: 'Click sort by descend',
    triggerAsc: 'Click sort by ascend',
    cancelSort: 'Click to cancel sort'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'Remove',
    selectCurrent: 'Select current page',
    removeCurrent: 'Remove current page',
    selectAll: 'Select all data',
    removeAll: 'Remove all data',
    selectInvert: 'Invert current page'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'No Data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand'
  },
  PageHeader: {
    back: 'Back'
  }
};
